import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import popupMessage from "../../../services/popupMessage";
import { instanceToken } from "../../../utils/constant";

export default function PopupMessages() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    fetchMessages(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchMessages = async (limit, offsetValue) => {
    try {
      const res = await popupMessage.findAll(
        instanceToken.token,
        limit,
        offsetValue
      );
      const result = res.data;
      setMessages(result?.popup_messages);
      setCount(result?.count);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/popup-messages/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "title",
      label: "Title",
      render: (row) => (
        <TruncatedCell
          value={row.title !== "undefined" ? row.title : "#"}
        />
      ),
    },
    {
      id: "image_url",
      label: "Image",
      render: (row) => (
        <Avatar
          alt="popup message"
          src={row.image_url}
          sx={{ width: 40, height: 40 }}
        />
      ),
    },
  ];

  return (
    <DataListPage
      title="Popup Messages"
      rows={messages || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/popup-message/create"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!messages}
    />
  );
}
